<div class="uploadPatientMRNMainDiv">
    <!-- <button mat-flat-button color="primary" class="btnSavePatientMRN" (click)="SavePatientMRN()"
        [ngClass]="(!selectedFileData?.length)?'btnDisabled':''" [disabled]="!selectedFileData?.length">
        Save
    </button>

    <div class="uploadFolder">
        <ng-container *ngIf="!selectedFileData?.length">
            <div class="messageDiv cursorPointer">
                <mat-icon class="cursorPointer messageSpacing" style="height: 2vw;
                width: 2vw;" svgIcon="uploadArrow"></mat-icon>
                <span class="messageSpacing">Drag and drop file here</span>
                <span class="messageSpacing">or</span>
                <span class="messageSpacing browseBtn">Browse for file</span>
            </div>

            <div class="uploadDiv">
                <input class="cursorPointer" type="file" #fileInput (change)="selectFile(fileInput.files)"
                    accept=".xlsx, .xls, .csv" placeholder="Browse Here"
                    style="opacity: 0; height: inherit; width: inherit; " />
            </div>
        </ng-container>
        <ng-container *ngIf="selectedFileData?.length">
            <div class="fileListingDiv">
                <mat-icon class="cursorPointer closeUploadIcon" (click)="resetUpload()">close</mat-icon>
                <div class="fileNameDisplay">
                    <mat-icon> insert_drive_file</mat-icon>
                    <span class="selectedFileName">
                        {{selectedFileName}}
                    </span>
                </div>
            </div>
        </ng-container>

    </div> -->
    <div class="usersHeaderDiv uploadHeaderDiv">
        <div class="usersHeaderTitle uploadHeaderTitle">
            Configure
        </div>
    </div>
    <div class="uploadTabDiv">
        <button *ngIf="!spinnerActive" mat-flat-button color="primary" class="btnSavePatientMRN"
            (click)="SavePatientMRN()" [ngClass]="(!selectedFileData?.length)?'btnDisabled':''"
            [disabled]="!selectedFileData?.length">
            Save</button>
        <mat-spinner *ngIf="spinnerActive" class="saveSpinner"></mat-spinner>
        <mat-tab-group [selectedIndex]="tabSelected">
            <mat-tab label="Metadata">
                <div class="uploadFolder">
                    <ng-container *ngIf="!selectedFileData?.length">
                        <div class="messageDiv cursorPointer">
                            <mat-icon class="cursorPointer messageSpacing" style="height: 2vw;
                            width: 2vw;" svgIcon="uploadArrow"></mat-icon>
                            <span class="messageSpacing">Drag and drop file here</span>
                            <span class="messageSpacing">or</span>
                            <span class="messageSpacing browseBtn">Browse for file</span>
                        </div>

                        <div class="uploadDiv">
                            <input class="cursorPointer" type="file" #fileInput (change)="selectFile(fileInput.files)"
                                accept=".xlsx, .xls, .csv" placeholder="Browse Here"
                                style="opacity: 0; height: inherit; width: inherit; " />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="selectedFileData?.length">
                        <div class="fileListingDiv">
                            <mat-icon class="cursorPointer closeUploadIcon" (click)="resetUpload()">close</mat-icon>
                            <div class="fileNameDisplay">
                                <mat-icon> insert_drive_file</mat-icon>
                                <span class="selectedFileName">
                                    {{selectedFileName}}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</div>